import React from 'react'

const imgStyle = {
    height: '220px',
    objectFit: 'cover',
    width: '100%',
    borderRadius: '4px',
}

const PHGInPictures = () => {
    return(
        <div className="container-fluid feature bg-light py-5">
        <div className="container py-5">
            <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                <h4 className="text-uppercase text-primary">Our Gallery</h4>
                <h1 className="display-3 text-capitalize mb-3">PHG In Pictures</h1>
            </div>
            <div className="row g-4">
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-1.jpg" alt="PHG in pictures 1" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-3.jpg" alt="PHG in pictures 3" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.6s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-2.jpg" alt="PHG in pictures 2" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.8s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-4.jpg" alt="PHG in pictures 4" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.0s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-5.jpg" alt="PHG in pictures 5" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.2s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-6.jpg" alt="PHG in pictures 6" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-7.jpg" alt="PHG in pictures 7" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-8.jpg" alt="PHG in pictures 8" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-9.jpg" alt="PHG in pictures 9" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.4s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-10.jpg" alt="PHG in pictures 10" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.6s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-11.jpg" alt="PHG in pictures 11" style={imgStyle} />
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="1.6s">
                    <div className="feature-item">
                        <img src="img/phg-in-pictures/uip-12.jpg" alt="PHG in pictures 12" style={imgStyle} />
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default PHGInPictures